import { render, staticRenderFns } from "./QuestionPanel.vue?vue&type=template&id=2b2aaf5c&scoped=true&"
import script from "./QuestionPanel.vue?vue&type=script&lang=js&"
export * from "./QuestionPanel.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPanel.vue?vue&type=style&index=0&id=2b2aaf5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2aaf5c",
  null
  
)

export default component.exports